import { createReducer } from '@reduxjs/toolkit';

import getListings from '../../thunks/listings/getListings';

const initialState = {
  loading: false,
  error: '',
  data: null,
  currentPage: 1,
  lastPage: undefined
};

const getListingsReducer = createReducer(initialState, {
  [getListings.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getListings.fulfilled]: (state, {
    payload: {
      data, current_page: currentPage, last_page: lastPage, refresh
    }
  }) => ({
    ...state,
    loading: false,
    data: [
      ...(!refresh ? state?.data : []),
      ...data
    ],
    currentPage,
    lastPage,
    refresh
  }),
  [getListings.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    data: null
  }),
});

export default getListingsReducer;
